import { render, staticRenderFns } from "./wait.vue?vue&type=template&id=3630925e&scoped=true"
import script from "./wait.vue?vue&type=script&lang=js"
export * from "./wait.vue?vue&type=script&lang=js"
import style0 from "./wait.vue?vue&type=style&index=0&id=3630925e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3630925e",
  null
  
)

export default component.exports